var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7V5.8C7 4.806 7.806 4 8.8 4H15.2C16.194 4 17 4.806 17 5.8V7",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 16,
    height: 13,
    rx: 2.2,
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H20",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12V13.2C10 13.642 10.358 14 10.8 14H13.2C13.642 14 14 13.642 14 13.2V12",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag2);
export default __webpack_public_path__ + "static/media/bag-2.ddd30d931059eb82d8ca0b4cf1436859.svg";
export { ForwardRef as ReactComponent };